module.exports = __webpack_public_path__ + "img/metamask-icon.bbc5afcc.svg";